module.exports = __webpack_public_path__ + "static/media/profile-bg.bcdaff1e.png";